import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import * as routerActions from 'connected-react-router'

// Actions
import { actions as staticpagesActions } from 'modules/staticpages/actions'

// Components
import { Error } from '@tracklib/kit'
import { StreamField } from 'components/staticpages/streamfield'
import SEO from 'components/base/seo'
import ThemeHelper from 'components/base/themehelper'

// Hooks
import { useRequest } from 'modules/requests/hooks'
import { usePages } from 'modules/entities/hooks'
import { useSubscription } from 'modules/subscription/hooks'

// Types
import { InitialDataProps, Dispatch } from 'types'

export const loadInitialData =
  ({
    location: {
      params: { name },
    },
  }: InitialDataProps<{ name: string }>) =>
  async (dispatch: Dispatch) => {
    const path = `campaigns/${name || ''}`
    return dispatch(staticpagesActions.loadPageByPath(path))
  }

const Campaign = () => {
  const dispatch = useDispatch()
  const subscription = useSubscription()
  const { name } = useParams() as { name: string }
  const path = `campaigns/${name || ''}`
  const fetchStaticPageRequest = useRequest('FETCH_STATIC_PAGE', path)
  const userOnFreeTier = ['FREE', 'TERMINATED'].includes(subscription?.state)

  const pages = usePages()
  const pageList = Object.keys(pages).map(id => pages[id])
  const page = pageList.find(p => p.meta.slug === name && p.meta.parent.meta.type === 'cms.CampaignPage')

  useEffect(() => {
    if (!page && !fetchStaticPageRequest.isLoading && !fetchStaticPageRequest.hasError) {
      dispatch(staticpagesActions.loadPageByPath(path))
    }
  }, [dispatch, fetchStaticPageRequest, page, path])

  useEffect(() => {
    if (subscription && !userOnFreeTier) {
      dispatch(routerActions.replace('/inspiration'))
    }
  }, [dispatch, subscription, userOnFreeTier])

  if (!page && fetchStaticPageRequest.isDone) {
    return <Error />
  }

  return (
    <>
      <SEO />
      {page && page?.theme && <ThemeHelper theme={page.theme} />}
      {page && <StreamField blocks={page.content} />}
    </>
  )
}

export default Campaign
